module.exports = __webpack_public_path__ + "static/media/NotoSans-LightItalic.0c294b05.ttf";